const remove = ({ data, oldData, draft }) => {
  if (!!draft?.items) {
    return {
      items: oldData?.items.filter((item: any) => item?.id !== data?.id),
    }
  }
  if (!!draft?.data) {
    return {
      data: oldData?.data.filter((item: any) => item?.id !== data?.id),
    }
  }
}

export default remove
